module.exports = __webpack_public_path__ + "static/media/comment-alt-info.d8484996.svg";